import React, { ReactElement } from "react";
import { Translate } from "react-redux-i18n";
import { useAppSelector } from "redux/hooks";
import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Typography,
  Box,
  Grid,
} from "@mui/material";
import { PlayedCouponSystems } from "redux/coupon/couponSlice";
import styles from './styles.module.scss'

export default function SystemDetail(): ReactElement {
  const playedCoupon = useAppSelector(state => state.coupon.playedCoupon);
  const divider = playedCoupon?.currency.divider
  const decimal = playedCoupon?.currency.decimal
  return (
    <Grid
      item
      sm={12}
      md={6}
      lg={6}
      className={styles.gridItem}>
      <Typography className={styles.systemGridTitle}>
        <Translate value="couponDetail.systemDetails" />
      </Typography>
      <TableContainer className={styles.tableContainer}>
        <Table className={styles.tableContainerDetail}>
          <TableHead>
            <TableRow  >
              <TableCell className={styles.systemCellHeader}>
                <Translate value="coupon.type" />
              </TableCell>
              <TableCell className={styles.systemCellHeader}>
                N.Col X {playedCoupon?.currency.symbol}
              </TableCell>
              <TableCell className={styles.systemCellHeader}>
                <Translate value="coupon.total" />
              </TableCell>
              <TableCell className={styles.systemCellHeader}>
                <Translate value="coupon.odd" />
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {
              playedCoupon &&
              playedCoupon
                .systems
                .map((system: PlayedCouponSystems) => {
                  return (
                    <TableRow
                      key={system.group}
                      className={styles.tableRow}>
                      <TableCell
                        size="small"
                        className={styles.systemCell}>
                        <Typography className={styles.tableCellText}>
                          {system.group}/{playedCoupon.events_count}
                        </Typography>
                      </TableCell>
                      <TableCell
                        size="small"
                        className={styles.systemCell}>
                        <Typography className={styles.tableCellText}>
                          {system.comb}x{divider && ((system.amount / system.comb) / divider).toFixed(4)}
                        </Typography>
                      </TableCell>
                      <TableCell
                        sx={{ textAlign: "right", }}
                        size="small"
                        className={styles.systemCell}>
                        <Typography className={styles.tableCellText}>
                          {divider && (system.amount / divider).toFixed(decimal)} {playedCoupon.currency.symbol}
                        </Typography>
                      </TableCell>
                      <TableCell
                        sx={{ textAlign: "right", }}
                        size="small"
                        className={styles.systemCell}>
                        <Box className={styles.systemCellLast}>
                          <Typography className={styles.tableCellText}>Min. {divider && (system?.win_min / divider).toFixed(decimal)} {playedCoupon.currency.symbol}</Typography>
                          <Typography className={styles.tableCellText}>Max. {divider && (system?.win_max / divider).toFixed(decimal)} {playedCoupon.currency.symbol}</Typography>
                        </Box>
                      </TableCell>
                    </TableRow>
                  )
                })}
          </TableBody>
        </Table>
      </TableContainer>
    </Grid>
  )
}